// src/lib/gtag.ts
export const GA_TRACKING_ID = "G-Q9TWPN3XN5"; 

// 初始化GA脚本
export const initGA = () => {
    if (typeof window === 'undefined' || !GA_TRACKING_ID) return;
    
    window.dataLayer = window.dataLayer || [];
    window.gtag = (...args: any[]) => window.dataLayer.push(args);
    window.gtag('js', new Date());
    window.gtag('config', GA_TRACKING_ID, { 
        send_page_view: false // 禁用自动页面跟踪，改为手动触发
    });
};

// 手动发送页面浏览事件
export const pageview = (url: string) => {
    gtag('event', 'page_view', {
        page_path: url
    });
};

// 发送自定义事件（如按钮点击）
export const event = (
    action: string, 
    params: { event_category?: string; event_label?: string; value?: number }
) => {
    gtag('event', action, params);
};